// Import Packages
import React from "react";
import { useTranslation } from "react-i18next";

// Import Material UI
import { Dialog, DialogContent, CircularProgress, Button } from '@material-ui/core';

// Import CSS
import './NewScopeModal.css';


const NewScopeModal = ({ modalSS, setOpenSimulatedScopeModal, handleAddNewScope }) => {
    const { t } = useTranslation();

    const label = 'CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.SCOPE.';

    const handleClose = () => {
        setOpenSimulatedScopeModal(false)
    }
    return (
        <Dialog
            open={true}
            PaperProps={{
                style: {
                    height: "80%",
                    width: "60%",
                    maxWidth: "100%",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "12px",
                    gap: "20px",
                    backdropFilter: "blur(3px)",
                    boxShadow: "none",
                    alignItems: "center",
                    justifyContent: "center"
                },
            }}
        >
            <h2 className="preview-new-scope-title">{t(label + "SCREENSHOT-AFTER-SIMILATION")}</h2>
            <img src={modalSS} className="modal-image" />
            <div className="preview-new-scope-buttons-container">
                <Button className="preview-new-scope-buttons cancel-button" onClick={handleClose}>{t(label + "NEW-SCOPE-PREVIEW-CANCEL-BUTTON")}</Button>
                <Button className="preview-new-scope-buttons create-button" onClick={() => handleAddNewScope()}>{t(label + "NEW-SCOPE-PREVIEW-CREATE-BUTTON")}</Button>
            </div>

        </Dialog>
    )
}

export default NewScopeModal;